import { AfterViewInit, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'app/profile/services/user.service';
import {finalize} from 'rxjs/operators';

import { getTranslation } from 'shared/helpers/get-translation';

import { NavService } from 'shared/nav/nav.service';
import { WeekData } from '../../model/week-data';
import { WeekService } from '../../services/week.service';

@Component({
  selector: 'resilience-panel',
  templateUrl: 'resilience-panel.html',
  styleUrls: ['resilience-panel.scss']})
export class ResiliencePanel implements AfterViewInit {

  private _loadingData: boolean = true;
  private _resources: Array<Dictionary<string>>;
  private _obstacles: Array<Dictionary<string>>;

  constructor(
    public navService: NavService,
    public translateService: TranslateService,
    public weekService: WeekService,
    public userService: UserService) { }

  public get resources(): Array<string> {
    if (this._resources === undefined || this._resources.length === 0) {
      return ['WEEK.NO_DATA'];
    }

    return this._resources.map((resource) => {
      return getTranslation(resource, this.translateService);
    });
  }

  public get obstacles(): Array<string> {
    if (this._obstacles === undefined || this._obstacles.length === 0) {
      return ['WEEK.NO_DATA'];
    }

    return this._obstacles.map((obstacle) => {
      return getTranslation(obstacle, this.translateService);
    });
  }

  public get loadingData(): boolean {
    return this._loadingData;
  }

  public ngAfterViewInit(): void {
    this._loadingData = true;
    this.loadData();
  }

  private loadData(): void {
    this._loadingData = true;

    this.weekService.getWeekData()
      .pipe(finalize(() => { this._loadingData = false; }))
      .subscribe((data: WeekData) => {

        this._resources = data.resources;
        this._obstacles = data.obstacles;

      });
  }

}
